# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class FeaturedExhibition extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'FeaturedExhibitionModule'
#
#   @selector: ".featured_exhibition_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# FeaturedExhibition.register()
